/**
 * Mantiene el mensaje de WhatsApp al día con la talla elegida en la ficha.
 *
 * Liquid ya escribe el enlace con la variante inicial; aquí solo lo reescribimos
 * cuando la clienta cambia de talla, para que la asesora reciba la que está
 * mirando de verdad y no la que venía por defecto.
 */
(() => {
  const LINKS = '[data-ec-wa][data-ec-wa-product]';

  const build = (link, sizeLabel) => {
    // Los rótulos vienen del propio enlace, que ya los trae en el idioma de la
    // página: si los fijáramos aquí, el inglés recibiría un mensaje en español.
    const d = link.dataset;
    const parts = [
      d.ecWaIntro || 'Hola, necesito ayuda con mi talla.',
      `${d.ecWaSeeing || 'Estoy viendo'}: ${d.ecWaProduct}`,
      d.ecWaUrl,
    ];
    if (sizeLabel) parts.push(`${d.ecWaPicked || 'Talla seleccionada'}: ${sizeLabel}`);

    link.href = `https://wa.me/${link.dataset.ecWaNumber}?text=${encodeURIComponent(parts.join('\n'))}`;
  };

  document.addEventListener('variant:update', (event) => {
    const variant = event.detail?.resource;
    if (!variant) return;

    // `title` trae la combinación completa ("M" o "M / Beige"): es lo que la
    // clienta ve y lo que la asesora necesita leer.
    const label = variant.title || '';

    document.querySelectorAll(LINKS).forEach((link) => build(link, label));
  });
})();
